var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('FixedCheckListTableComponent',{attrs:{"typeName":"定期清掃","type":3,"routerName":_vm.routerName,"scheduledDate":_vm.scheduledDate,"siteLocation":_vm.siteLocation}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }